import toast from "react-hot-toast";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";

export default class AffiliateBranchesFormPresenter extends BaseFormPresenter {
  //   async save() {
  //     const collection = this.view.getCollectionName();
  //     if (this.object.id) {
  //       this.change.id = this.object.id;
  //     } else {
  //       this.change.acl = this.view.getAcl();
  //     }
  //     console.log("this send", this.change);
  //     try {
  //       //   await this.upsertUseCase.execute(collection, this.change);
  //       this.change = {};
  //     } catch (error) {
  //       throw error;
  //     }
  //   }

  async save() {
    const collection = this.view.getCollectionName();

    // Add ACL if new record
    if (this.object.id) {
      this.change.id = this.object.id;
      // this.change.clientCode = `${this.object?.code || this.change?.code}-${
      //   this.change?.name || this.object?.name
      // }`;
      this.change.code = `${
        this.object?.clientCode || this.change?.clientCode
      }-${this.change?.name || this.object?.name}`;
    } else {
      this.change.acl = this.view.getAcl();
    }

    // Combine code and name into clientCode
    if (this.change.clientCode && this.change.name) {
      this.change.code = `${this.change.clientCode}-${this.change.name}`;
    }

    console.log("this send", this.change);

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      await this.view.showConfirmationDialog();
      await this.save();
      this.view.submissionSuccess();
      toast.success("Successfully saved!", { position: "top-right" });
      this.view.navigateBack();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}
